export const en = {
  common: {
    cancel: 'Cancel', confirm: 'Confirm', close: 'Close', save: 'Save', done: 'Done',
    back: 'Back', next: 'Next', retry: 'Try again', loading: 'Loading', today: 'Today',
    tomorrow: 'Tomorrow', hours: 'hrs', perHour: '/hour', somethingWrong: 'Something went wrong.',
    all: 'All', none: 'None',
  },
  nav: {
    dashboard: 'Dashboard', shifts: 'Shifts', timesheets: 'Timesheets',
    workers: 'Workers', billing: 'Billing',
  },
  auth: {
    title: 'Pinch Crew for Business',
    subtitle: 'Post shifts, and vetted crew claim them. You approve the hours; we pay the workers.',
    email: 'Work email',
    password: 'Password',
    signIn: 'Sign in',
    demoHint: 'Demo mode — any email, password is demo1234',
    invalid: 'Wrong email or password.',
    chooseOrg: 'Choose a company',
    chooseOrgBody: 'You have access to more than one. You can switch at any time.',
  },
  dashboard: {
    title: 'Today',
    coverage: 'Coverage today',
    coverageValue: '{filled} of {required} filled',
    shiftsToday: 'Shifts today',
    notClockedIn: 'Not clocked in',
    notClockedInHint: 'Workers past their start time without a clock-in',
    pendingTimesheets: 'Awaiting approval',
    balance: 'Available balance',
    atRisk: 'Short-staffed and starting soon',
    atRiskBody: 'These shifts start within 24 hours and still need crew.',
    atRiskEmpty: 'Everything starting soon is fully staffed',
    atRiskEmptyBody: 'Nothing needs your attention right now.',
    needsMore: 'needs {n} more',
    viewShift: 'View',
    allGood: 'All clear',
  },
  shifts: {
    title: 'Shifts',
    post: 'Post a shift',
    empty: 'No shifts yet',
    emptyBody: 'Post your first shift and vetted crew can claim it.',
    filled: 'Fully staffed',
    open: 'Open',
    completed: 'Completed',
    cancelled: 'Cancelled',
    inProgress: 'In progress',
    ofHeadcount: '{filled}/{headcount} filled',
    roster: 'Roster',
    noClaims: 'Nobody has claimed this yet',
    noClaimsBody: 'Workers who match the role and tier can see it now.',
    release: 'Remove from shift',
    releaseConfirm: 'Remove {name} from this shift?',
    releaseBody: 'The slot reopens for other workers. Close to the start time this can leave you short.',
    cancelShift: 'Cancel shift',
    cancelConfirm: 'Cancel this shift?',
    cancelBody: 'The hold on your balance is released. Anyone who claimed it is notified.',
    cancelReason: 'Why are you cancelling?',
    clockedIn: 'Clocked in {time}',
    awaitingClockIn: 'Not clocked in',
    rate: 'Rate this worker',
    rateBody: 'Ratings feed the reliability score and who we show your shifts to first.',
    rateStars: 'Stars',
    rateComment: 'Anything to add?',
    rateSubmit: 'Submit rating',
  },
  post: {
    title: 'Post a shift',
    site: 'Which site?',
    skill: 'What role?',
    minTier: 'Minimum tier',
    minTierHint: 'Higher tiers cost more per hour but need less supervision',
    date: 'Date',
    startTime: 'Start',
    endTime: 'End',
    headcount: 'How many people?',
    breakPaid: 'Paid break (minutes)',
    dressCode: 'What should they wear?',
    instructions: 'Where do they report?',
    repeat: 'Repeat weekly',
    repeatDays: 'On these days',
    repeatWeeks: 'For how many weeks?',
    cost: 'What this costs',
    workerPay: 'Worker pay',
    platformFee: 'Platform fee',
    processingFee: 'Payment processing',
    total: 'Total',
    costNote: 'Charged when you post. Unworked hours are credited back to your balance.',
    insufficient: 'Not enough balance',
    insufficientBody: 'Top up {amount} to post this shift.',
    topUpNow: 'Top up',
    publish: 'Post and pay {amount}',
    publishing: 'Posting…',
    posted: 'Shift posted',
    postedBody: 'Vetted crew can see it now. We will notify you as they claim it.',
    postedMulti: '{n} shifts posted',
    errors: {
      invalid_times: 'The end time must be after the start time.',
      invalid_headcount: 'You need at least one worker.',
      insufficient_funds: 'Your balance is too low to post this shift.',
    },
  },
  timesheets: {
    title: 'Timesheets',
    pending: 'Awaiting approval',
    approved: 'Approved',
    disputed: 'Disputed',
    settled: 'Paid',
    empty: 'Nothing to approve',
    emptyBody: 'Hours appear here after a shift finishes.',
    approve: 'Approve',
    approveAll: 'Approve all ({n})',
    approveAllConfirm: 'Approve {n} timesheets?',
    approveAllBody: 'This releases payment to those workers. You cannot undo it.',
    adjust: 'Adjust hours',
    adjustTitle: 'Adjust the hours',
    adjustBody: 'Use this only when the clock record is genuinely wrong. The worker is notified and can contest it.',
    adjustHours: 'Hours to pay',
    adjustReason: 'Why the change?',
    scheduled: 'Scheduled',
    actual: 'Clocked',
    autoApproves: 'Auto-approves {when}',
    autoNote: 'Anything you do not act on approves automatically after {n} hours, so workers are not left waiting.',
    yourCost: 'Your cost',
    workerGets: 'Worker gets',
  },
  workers: {
    title: 'Workers',
    all: 'Your pool',
    favourites: 'Favourites',
    blocked: 'Blocked',
    empty: 'No workers yet',
    emptyBody: 'Workers appear here once they have worked a shift for you.',
    shiftsWorked: '{n} shift here | {n} shifts here',
    reliability: 'Reliability {n}',
    favourite: 'Favourite',
    unfavourite: 'Remove favourite',
    block: 'Block',
    unblock: 'Unblock',
    blockConfirm: 'Block {name}?',
    blockBody: 'They will not see your shifts again. This does not affect their standing with other employers.',
    blockReason: 'Why? (private to you)',
    favouriteHint: 'Favourites see your shifts first.',
  },
  billing: {
    title: 'Billing',
    balance: 'Balance',
    available: 'Available',
    held: 'Held for posted shifts',
    heldHint: 'Reserved for shifts you have posted. Released if a shift is cancelled.',
    topUp: 'Top up',
    topUpTitle: 'Top up your balance',
    topUpBody: 'Shifts draw against this balance as you post them.',
    amount: 'Amount',
    method: 'How are you paying?',
    topUpConfirm: 'Top up {amount}',
    topUpDone: 'Balance topped up',
    activity: 'Activity',
    invoices: 'Invoices',
    invoiceStatus: { draft: 'Draft', issued: 'Issued', paid: 'Paid', overdue: 'Overdue' },
    due: 'Due {date}',
    entryKind: {
      topup: 'Top up', booking_hold: 'Held for shift', booking_release: 'Hold released',
      settlement_debit: 'Shift settled', settlement_credit: 'Credit returned',
      fee: 'Platform fee', refund: 'Refund', withdrawal: 'Withdrawal', adjustment: 'Adjustment',
    },
    empty: 'No activity yet',
  },
  org: { switch: 'Switch company', signOut: 'Sign out', language: 'Language' },
  siteQr: {
    title: 'Check-in code',
    site: 'Site',
    alt: 'Pinch Crew check-in QR code',
    hint: 'Workers scan this to clock in and out.',
    rotates: 'Changes in {n}s',
    refresh: 'Refresh now',
    openDisplay: 'Show check-in code',
  },
  signup: {
    title: 'Hire part-timers with Pinch Crew',
    subtitle: 'Post a shift, we send vetted crew. Create your company account in a minute.',
    company: 'Company name',
    contact: 'Your name',
    email: 'Work email',
    emailHint: 'This is also where invoices go.',
    password: 'Password',
    passwordHint: 'At least 8 characters.',
    approvalNote: 'We check every new company before the first shift goes live, usually within one working day. You can look around while you wait.',
    cta: 'Create account',
    sendCode: 'Continue',
    verifyTitle: 'Check your email',
    verifySubtitle: 'We sent a 6-digit code to {email}. It expires in 5 minutes.',
    code: 'Verification code',
    codeHint: 'Six digits from the email we just sent.',
    wrongEmail: 'Wrong email? Go back',
    haveAccount: 'Already have an account?',
    haveNoAccount: 'New to Pinch Crew?',
    signIn: 'Sign in',
    pendingTitle: 'We are reviewing your company',
    pendingBody: 'You can look around now. Posting shifts unlocks as soon as we approve you, usually within one working day.',
  },
}
